// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../demo/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toolbar-custom-icon {\n  line-height: 1;\n  vertical-align: middle;\n}\n", ""]);
// Exports
module.exports = exports;
